import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';

import cx from 'classnames';

import Link from '../Link';

import messages from '../../locale/messages';
import history from '../../core/history';

import s from './AccountSettingsSideMenu.css';
const AccountSettingsSideMenu = () => {

    const [location, setLocation] = useState('');

    useEffect(() => {
        if (history.location) {
            setLocation(history.location.pathname);
        }
    }, [location])


    return (
        <div>
            <ul className={cx('sideMenuBorder')}>
               {/*  <li className={cx('sideMenuBorderPadding', { ['menuActive']: location === "/user/payout" || location === "/user/addpayout" })}>
                    <Link to={"/user/payout"} className={cx('sideNavitem', 'sideNav')}>
                        <FormattedMessage {...messages.payoutPreferences} />
                    </Link>
                </li>
                <li className={cx('sideMenuBorderPadding', { ['menuActive']: location.startsWith("/user/transaction") })}>
                    <Link to={"/user/transaction/completed"} className={cx('sideNavitem', 'sideNav')}>
                        <FormattedMessage {...messages.transactionHistory} />
                    </Link>
                </li> */}
                <li className={cx('sideMenuBorderPadding', { ['menuActive']: location === "/users/security" })}>
                    <Link to={"/users/security"} className={cx('sideNavitem', 'sideNav')}>
                        <FormattedMessage {...messages.security} />
                    </Link>
                </li>
                <li className={cx('sideMenuBorderPadding', { ['menuActive']: location === "/users/delete-user" })}>
                    <Link to={"/users/delete-user"} className={cx('sideNavitem', 'sideNav')}>
                        <FormattedMessage {...messages.manageYourAccount} />
                    </Link>
                </li>
            </ul>
        </div>
    );
}

export default withStyles(s)(AccountSettingsSideMenu);